/*
 *
 * PlanAParty reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  SUBMIT_PLAN_A_PARTY,
} from './constants';

const initialState = fromJS({ submit_res: {} });

function planAPartyReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case SUBMIT_PLAN_A_PARTY:
      return state
        .set('submit_res', fromJS(payload));
    default:
      return state;
  }
}

export default planAPartyReducer;



// WEBPACK FOOTER //
// client/containers/PlanAParty/reducer.js